import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=741386b4&"
import script from "./LeadsList.vue?vue&type=script&lang=js&"
export * from "./LeadsList.vue?vue&type=script&lang=js&"
import style0 from "./lead-flow-theme.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports